import { Box, Button, Text } from "@chakra-ui/react";
import Card from "components/card/Card";
import { useService } from "hooks/ServicesHook";
import { useState } from "react";
import { useQuery } from "react-query";
import { ModalBKP } from "./ModalBKP";

export function CardInfoClick() {
  const [openModal, setIsOpenModal] = useState<boolean>(false);
  const [qtdBKP, setQtdBKP] = useState<number>(0);
  const [typeModal, setTypeModal] = useState<"N" | "S">();

  interface handleOpenModalProps {
    typeModal: "S" | "N";
  }

  const { findResultsBKPs } = useService();
  const { data, isLoading, error } = useQuery(
    ["findResultsBKPs"],
    () => findResultsBKPs(),
    {
      retry: false,
    }
  );

  const handleOpenModal = ({ typeModal }: handleOpenModalProps) => {
    setIsOpenModal(true);
    setQtdBKP(typeModal === "S" ? data?.success : data?.error);
    setTypeModal(typeModal);
  };

  return (
    <Card>
      <Box mb={4}>
        <Text fontWeight={800}>Clientes Backup</Text>
      </Box>

      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        gap={4}
      >
        {error ? (
          <Text color={"red.500"}>{String(error)}</Text>
        ) : (
          <>
            <Button
              onClick={() => handleOpenModal({ typeModal: "S" })}
              isLoading={isLoading}
            >
              Sucessos - {data?.success}
            </Button>
            <Button
              onClick={() => handleOpenModal({ typeModal: "N" })}
              isLoading={isLoading}
            >
              Erros - {data?.error}
            </Button>
          </>
        )}
      </Box>

      {openModal ? (
        <ModalBKP
          isOpen={openModal}
          onClose={() => setIsOpenModal(false)}
          typeModal={typeModal}
          qtdBKP={qtdBKP}
        />
      ) : null}
    </Card>
  );
}
